module.exports = __webpack_public_path__ + "static/media/lunar-app_2screen.d48b5684.png";